module.exports = __webpack_public_path__ + "static/img/icon_signup.24fddf46.png";